const url = '/currencies';
const Provider = 'currencies';
const dbModel = 'currencies';

export { url, Provider, dbModel };
export const TABLE_NAME = 'currencies';
